"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn) {
      router.replace("/daily-brief");
    } else {
      router.replace("/signin");
    }
  }, [router]);

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center font-sans antialiased text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-zinc-800 border-t-blue-500 rounded-full animate-spin"></div>
        <p className="text-zinc-400 text-xs font-semibold tracking-wider uppercase">
          Redirecting...
        </p>
      </div>
    </div>
  );
}



